// Components==============
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import './MobileSharecodeButton.module.scss';
// =========================

export default function MobileSharecodeButton({
  sharecode,
}: {
  sharecode: string;
}) {
  const [status, setStatus] = useState<'inactive' | 'copied'>('inactive');

  function copiedClick() {
    navigator.clipboard.writeText(sharecode);
    setStatus('copied');
    return setTimeout(function () {
      setStatus('inactive');
    }, 2000);
  }
  return (
    <button type="button" onClick={copiedClick}>
      Sharecode:{' '}
      <span style={{ color: status === 'copied' ? '#2addd0' : '#0827e9' }}>
        {sharecode} <FontAwesomeIcon icon={faCopy} />
      </span>
    </button>
  );
}
